import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import { ExperimentEndScreen } from 'routing/sharedPages/ExperimentEndScreen'
import SplashScreen from 'routing/sharedPages/SplashScreen'
import { PreSplashScreen } from 'routing/sharedPages/PreSplashScreen'
import PCWBasketScreen from './pageDirectory/PCWBasketScreen'
import PCWTableScreen from './pageDirectory/PCWTableScreen'
// import ConditionSelection from './pageDirectory/ConditionSelection'
import {
  getHidePreSplashScreen,
  getHideSplashScreen,
} from '../../redux/reducers/dataStore/dataStore.selectors'

const PCWJourney: FC = () => {
  const hideSplashScreen = useSelector(getHideSplashScreen)
  const hidePreSplashScreen = useSelector(getHidePreSplashScreen)

  return (
    <Switch>
      {/* <Route exact path="/">
        <ConditionSelection />
      </Route> */}
      {!hidePreSplashScreen && (
        <Route exact path="/">
          <PreSplashScreen
            nextPath={hideSplashScreen ? 'tableScreen' : '/splashScreen'}
          />
        </Route>
      )}
      {!hideSplashScreen && (
        <Route path="/splashScreen">
          <SplashScreen nextPath="/tableScreen" />
        </Route>
      )}
      <Route path="/tableScreen">
        <PCWTableScreen nextPath="/basketPage" />
      </Route>
      <Route path="/basketPage">
        <PCWBasketScreen />
      </Route>
      <Route path="/experimentEnd">
        <ExperimentEndScreen />
      </Route>
      {!hidePreSplashScreen && <Redirect push to="/" />}
      {!hideSplashScreen && <Redirect push to="/splashScreen" />}
      <Redirect push to="/tableScreen" />
    </Switch>
  )
}

export default PCWJourney
